import { render, staticRenderFns } from "./GlobalSettingPage.vue?vue&type=template&id=2698da33&scoped=true"
import script from "./GlobalSettingPage.vue?vue&type=script&lang=js"
export * from "./GlobalSettingPage.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettingPage.vue?vue&type=style&index=0&id=2698da33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698da33",
  null
  
)

export default component.exports